export default "__VITE_ASSET__b2bef2cf__"